import React, { useRef, useState } from 'react'
import styles from './main.module.css'
import Project1 from '../../components/project1/Project1'
import Project2 from '../../components/project2/Project2'
import Project3 from '../../components/project3/Project3'
import Project4 from '../../components/project4/Project4'
import Intro from '../../components/intro/Intro'
import Skills from '../../components/skills/Skills'
import { useEffect } from 'react'
import Contact from '../../components/contact/Contact'
import {Close, CopyrightOutlined,Menu} from '@mui/icons-material/';
import { useWindowSize } from '../../context/WindowSizeContext'


export default function Main() {
  const skillsRef=useRef()
  const aboutRef=useRef();
  const contactRef=useRef();
  const projectHeaderRef=useRef();
  const project1Ref=useRef();
  const project2Ref=useRef();
  const project3Ref=useRef();
  const project4Ref=useRef();
  const [project1PosY,setProject1PosY]=useState({top:project1Ref.current?.getBoundingClientRect().top,
                                                 bottom:project1Ref.current?.getBoundingClientRect().bottom})
  const [project2PosY,setProject2PosY]=useState({top:project2Ref.current?.getBoundingClientRect().top,
                                                  bottom:project2Ref.current?.getBoundingClientRect().bottom})
  const [project3PosY,setProject3PosY]=useState({top:project3Ref.current?.getBoundingClientRect().top,
                                                    bottom:project3Ref.current?.getBoundingClientRect().bottom})
  const [project4PosY,setProject4PosY]=useState({top:project4Ref.current?.getBoundingClientRect().top,
                                                      bottom:project4Ref.current?.getBoundingClientRect().bottom})
  const [skillsPosY,setSkillsPosY]=useState(skillsRef.current?.getBoundingClientRect().top);
  const [aboutAnime,setAboutAnime]=useState(false);
  const [contactPosY,setContactPosY]=useState(contactRef.current?.getBoundingClientRect().top)
  const [isBackdrop,setIsBackDrop]=useState(false)
  const {innerWidth}=useWindowSize();
  
  useEffect(()=>{
    window.scroll({top:0,behavior:"smooth"})

  },[])

  console.log(aboutAnime)
 
  useEffect(()=>{
    const scroll=()=>{
      const project1Pos={top:project1Ref.current?.getBoundingClientRect().top,bottom:project1Ref.current?.getBoundingClientRect().bottom}
      const project2Pos={top:project2Ref.current?.getBoundingClientRect().top,bottom:project2Ref.current?.getBoundingClientRect().bottom}
      const project3Pos={top:project3Ref.current?.getBoundingClientRect().top,bottom:project3Ref.current?.getBoundingClientRect().bottom}
      const project4Pos={top:project4Ref.current?.getBoundingClientRect().top,bottom:project4Ref.current?.getBoundingClientRect().bottom}
      
       setSkillsPosY(skillsRef.current?.getBoundingClientRect().top)
       setProject1PosY(current=>({
        ...current,...project1Pos
       }))
       setProject2PosY(current=>({
        ...current,...project2Pos
       }))
       setProject3PosY(current=>({
        ...current,...project3Pos
       }))
       setProject4PosY(current=>({
        ...current,...project4Pos
       }))
       setContactPosY(contactRef.current?.getBoundingClientRect().top)
       if(aboutRef.current?.getBoundingClientRect().top < 80)
       setAboutAnime(true)
    }
    window.addEventListener('scroll',scroll)

    return ()=>window.removeEventListener('scroll',scroll)
  },[])
   
  const scrollSW=(place)=>{
   if(isBackdrop){
    if(place === "intro") window.scroll({top:0,behavior:"smooth"})
    if(place === "works")projectHeaderRef.current?.scrollIntoView({behavior:"smooth"})
    else if(place === "about") aboutRef.current?.scrollIntoView({behavior:"smooth"})
    else if(place === "contact") contactRef.current?.scrollIntoView({behavior:"smooth"})
    else if(place === "skills") skillsRef.current?.scrollIntoView({behavior:"smooth"})

    setIsBackDrop(false)
   }
  }

  return (
    <div className={styles.main}>
      <div className={styles.navbar}>
       {!isBackdrop && <Menu  style={{fontSize:"35px"}} className={styles["menu-icon"]} 
                         onClick={()=>setIsBackDrop(true)}/>}
      </div>
      <div className={styles.backdrop} style={{opacity:isBackdrop? 1: 0, 
                                               visibility: isBackdrop ? "visible" : "hidden"//  zIndex: isBackdrop? 100 : 1,
                                               }}>
        <div className={styles.close}>
        {isBackdrop && <Close style={{fontSize:"35px"}} className={styles["close-icon"]} 
                                          onClick={()=>setIsBackDrop(false)}/>}
        </div>
        <ul className={styles.list}>
          <li className={styles["list-item"]} onClick={()=>scrollSW("intro")}>Intro</li>
          <li className={styles["list-item"]} onClick={()=>scrollSW("works")}>Works</li>
          <li className={styles["list-item"]} onClick={()=>scrollSW("about")}>About</li>
          <li className={styles["list-item"]} onClick={()=>scrollSW("skills")}>Skills</li>
          <li className={styles["list-item"]} onClick={()=>scrollSW("contact")}>Contact</li>
        </ul>
      </div>
      <div className={styles.intro}>
        <Intro/>
      </div>
      <div className={styles.projects} ref={projectHeaderRef}>
        <h1 className={styles.header}>Works</h1>
         <div className={styles.project4} ref={project4Ref}>
          <Project4 position={project4PosY}/>
         </div>
         <div className={styles.project1} ref={project1Ref}>
          <Project1 position={project1PosY}/>
         </div>
         <div className={styles.project2} ref={project2Ref}>
          <Project2 position={project2PosY}/>
         </div>
         <div className={styles.project3} ref={project3Ref}>
          <Project3 position={project3PosY}/>
         </div>
      </div>
      <div className={styles.about} ref={aboutRef}>
      <h1 className={styles.header}>About</h1>
      <div className={styles.name} 
           style={{transform: aboutAnime ? "translateY(0)" : "translateY(100px)",
                   opacity: aboutAnime ? 1 : 0}}>
            Ryo Aoyama
      </div>
      <div className={styles.contents} 
           style={{transform: aboutAnime ? "translateY(0)" : "translateY(100px)",
                   opacity: aboutAnime ? 1 : 0}}>
       {/* <p className={styles.notice}>My photo is currently unavailable</p> */}
       {/* <div className={styles.me}></div> */}
       <div className={styles.photoContainer}>
        <img src="./images/doraemon2.png" alt="" className={styles.me} />
        <p className={styles.notice}>My photo is currently unavailable.</p>
       </div>
       <div className={styles["text-container"]}>
          <p className={styles.paragraph}>
          <span className={styles["para-header"]}>Who I am.</span><br/>
           I am Ryo, a Japanese web developer who loves design and coding.
           I am also an ambicious, hard-working person and passionate about learing new things.
          </p>
          <p className={styles.paragraph}>
          <span className={styles["para-header"]}>How I work.</span><br/>
           During work, I am highly responsible to my job and dedicate every bit of myself to it. 
           I am a great team player who values collaboration and works well with others to achieve 
           common goals and also an avid learner who approaches new challenges with enthusiasm and 
           a willingness to grow.
          </p>
          <p className={styles.paragraph}>
          <span className={styles["para-header"]}>What I love.</span><br/>
           My favourite stuffs are coding and soccer. 
           I enjoy the process of creating and building new things through programming.
           Sometimes, I spend over 10 hours on programming a day.
           Playing soccer allows me to stay active and healthy. 
           It is a way of bringing joy and fulfillment to my life.
          </p>
          <div className={styles.icons}>
           <a href="https://www.linkedin.com/in/ryo-aoyama-21392222b/"><img src="./images/linkedin2.png" alt="" className={styles.icon} /></a>
           <a href='https://github.com/RyoGitacc'><img src="./images/github-mark.png" alt="" className={styles.icon} /></a>
          </div>
       </div>
      </div>
    </div>
      <div className={styles.skills}>
        <h1 className={styles.header} ref={skillsRef}>Skills</h1>
        <div className={styles["skills-container"]} >
          <Skills position={skillsPosY}/>
        </div>
      </div>
      <div className={styles.contact}>
       <h1 className={styles.header}>Contact</h1>
       <div ref={contactRef}>
        <Contact position={contactPosY}/>
       </div>
      </div>
      <div className={styles.copyright}>
         <CopyrightOutlined className={styles.copyrightLogo} 
          style={{fontSize:innerWidth > 500 ?"15px" : "12px"}}/>Ryo Aoyama
      </div>
    </div>
  )
}
